import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    alignitems: flex-end;
    justifycontent: space-between;
    img {
        width: 10%;
    }
`
